import React from 'react';
import { Link } from 'react-router-dom';

import { LINKS, COPIES } from '../../../../constants';

const LifeAtFiverrLink = () => (
    <Link to={`/${LINKS.LIFE_AT_FIVERR}`} className="nav-link">
        {COPIES.lifeAtFiverr}
    </Link>
);

export default LifeAtFiverrLink;
